import { AgGridReact } from "ag-grid-react";
import React, { Component } from "react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { CircularProgress } from "@material-ui/core";

class AgGridTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultColDef: {
        sortable: true,
        filter: true,
        suppressMenu: true
      },
      rowData: [],
    };
  }

  UNSAFE_componentWillReceiveProps(newprpps) {
    const { columnDefs, rowData } = this.props;

    this.setState({ loading_state_iocn: true });

    if (newprpps.rowData !== rowData) {
      this.setState({ rowData: newprpps.rowData });
    }
  }

  componentWillMount() {
    const { rowData, columnDefs } = this.props;

    this.setState({ rowData: rowData });
  }
  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  onBtnExportDataAsCsv(params) {
    this.gridApi.exportDataAsCsv(params);
  }
  render() {
    const { columnDefs, loading_state_Table } = this.props;
    const { defaultColDef, rowData } = this.state;

    return (

      <div
        className="ag-theme-balham"
        style={{ height: "700px", width: 1200, backgroundColor: 'transparent' }}

      >
        <button

          onClick={() => this.onBtnExportDataAsCsv()}
        >
          تصدير ملف اكسل
        </button>


        {loading_state_Table == true ? (
          <CircularProgress size={50} />
        ) : (
          <AgGridReact
            defaultColDef={defaultColDef}
            columnDefs={columnDefs}
            rowData={rowData}
            onGridReady={this.onGridReady}
            headerHeight={90}
          />
        )}
      </div>

    );
  }
}
export default AgGridTable;
